module.exports = __webpack_public_path__ + "resource/img/banner01.jpg?35e7432fc775f7ee25cc173f9a881bb9";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner01.jpg
// module id = 451
// module chunks = 36